module.exports = __webpack_public_path__ + "img/OK_XFGL_zh.f0b05e64.png";